import axios from "axios";
export default async function ApiInsertarBusquedaClic(params) {
  let url = "/app/api/buscadorcore/v1/REGISTRABUSQUEDACLICK"
  const header = {
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    };
  await axios.post(url, params, header);
}